
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';
import Collapse from 'bootstrap/js/dist/collapse';

import loadModalFromTemplate from "./modal"

/**
 * Possible anchor link actions:
 * - scroll to an element on the page
 * - open a modal
 * - select a tab
 * - open an accordion
 */

// INIT

function akaInitAllAnchorLinks() {
    const linkedElts = document.querySelectorAll('a[href], button[role="tab"]');
    akaConvertAbsoluteLinkedEltsToRelative(linkedElts);
    akaAddAnchorLinkListeners(linkedElts);

    const navs = document.querySelectorAll('.nav');
    const hash = akaGetUrlFragment(window.location.href);

    /**
     * URL has hash and nav has matching hash --> clear all, activate matching
     * URL has hash and nav doesn't have matching hash --> clear only nav items that have a hash
     * URL doesn't have hash --> clear only nav items that have a hash
     */
    // No hash in the URL: Clear active state from nav links with a hash
    if (navs) {
        navs.forEach(nav => {
            if (!hash) {
                akaClearActiveStatesFromLinks(nav, true)
            } else {
                if (akaNavHasMatchingLink(nav, hash)) {
                    akaClearActiveStatesFromLinks(nav)
                    akaSetNavItemActiveState(nav, hash);
                } else {
                    akaClearActiveStatesFromLinks(nav, true)
                }
            }
        });
    }

    // if (navs) {
    //     navs.forEach(nav => {
    //         akaClearActiveStatesFromLinks(nav, !hash)
    //         if (hash) {
    //             akaSetNavItemActiveState(nav, hash);
    //         }
    //     });
    // }
}

// ACTIONS

function akaDoActionModal(urlFragment) {
    let theModal = Modal.getInstance('#modal')
    loadModalFromTemplate(theModal._element, `#${urlFragment}`)
    theModal.toggle()
    akaDeleteUrlFragmentOnEvent(urlFragment, theModal._element, 'hide.bs.modal')
}

/**
 * When an {event} for {elt} is triggered, remove {urlFragment} from the current URL.
 *
 * @param {string} urlFragment
 * @param {Element} elt
 * @param {string} event
 */
function akaDeleteUrlFragmentOnEvent(urlFragment, elt, event) {
    let onEvent = function(e) {
        akaDeleteUrlFragment(urlFragment)
        elt.removeEventListener(event, onEvent)
    }
    elt.addEventListener(event, onEvent);
}

function akaDoActionTab(urlFragment) {
    akaDoActionScrollTo(urlFragment);

    let elt = document.getElementById(urlFragment);
    if (elt.attributes.role.nodeValue == 'tabpanel') {
        elt = document.getElementById(elt.attributes['aria-labelledby'].nodeValue);
    }
    let tab = new Tab(elt);
    tab.show();
    akaDeleteUrlFragmentOnEvent(urlFragment, tab._element, 'hide.bs.tab')
}

function akaDoActionAccordion(urlFragment) {
    akaDoActionScrollTo(urlFragment);

    let accordionItem = new Collapse(`#${urlFragment}`);
    accordionItem.show(true);
    akaDeleteUrlFragmentOnEvent(urlFragment, accordionItem._config.parent, 'hide.bs.collapse')
}

function akaDoActionScrollTo(urlFragment) {
    let targetElt = document.querySelector(`#${urlFragment}`);
    targetElt.scrollIntoView()
}

// EVENT LISTENERS

window.addEventListener('hashchange', function(event) {
    if (!event.newURL) return;
    if (akaHasUrlFragmentChanged(event.oldURL, event.newURL)) {
        akaHandleURLFragmentChange(event.newURL)
    }

    let navLinks = document.querySelectorAll('.nav .nav-link[href]');
    let matchingNavs = [];
    const urlFragment = akaGetUrlFragment(event.newURL);
    for (let link of navLinks) {
        if (link.href.indexOf(`#${urlFragment}`) != -1) {
            matchingNavs.push(link.closest('.nav'));
        }
    }
    if (matchingNavs) {
        matchingNavs.forEach(nav => {
            akaClearActiveStatesFromLinks(nav);
            akaSetNavItemActiveState(nav, hash);
        });
    }
});
// window.addEventListener('popstate', (e) => {
//     if (!akaHasUrlFragmentChanged(window.location.href, event.newURL))
//     akaHandleURLFragmentChange()
// });
document.addEventListener('DOMContentLoaded', function() {
    akaHandleURLFragmentChange()
    akaInitAllAnchorLinks()
});

function akaInitListenerModal(hash) {
    akaDoActionModal(hash)
}
function akaInitListenerTab(hash) {
    let elt = document.getElementById(hash);
    elt.addEventListener('click', (event) => {
        event.preventDefault();
        akaDoActionTab(hash)
    })
}
function akaInitListenerAccordion(hash) {
    akaDoActionAccordion(hash)
}
function akaInitListenerScrollTo(hash) {
    akaDoActionScrollTo(hash)
}

/**
 * Returns true if the current URL fragment does not equal the new URL fragment,
 * otherwise false.
 *
 * @param {string} urlA
 * @param {string} urlB
 * @returns {boolean}
 */
function akaHasUrlFragmentChanged(urlA, urlB) {
    const urlFragmentA = akaGetUrlFragment(urlA)
    const urlFragmentB = akaGetUrlFragment(urlB)
    return urlFragmentA !== urlFragmentB;
}

/**
 * If {url} contains a URL fragment and an element with a matching ID exists, do
 * the appropiate action (open/close modal, open/close accordion, etc.).
 *
 * @param {string} url
 */
function akaHandleURLFragmentChange(url) {
    url = url || window.location.href
    let urlFragment = akaGetUrlFragment(url);
    if (!urlFragment) return;

    if (akaIsTargetModal(urlFragment)) {
        akaDoActionModal(urlFragment);
    } else if (akaIsTargetTab(urlFragment)) {
        akaDoActionTab(urlFragment);
    } else if (akaIsTargetAccordion(urlFragment)) {
        akaDoActionAccordion(urlFragment);
    } else if (akaIsTargetScrollTo(urlFragment)) {
        akaDoActionScrollTo(urlFragment);
    }
}

/**
 * For all elements within {linkedElts} that contain a URL fragment, add a click
 * event listener if there's an element with an ID matching the URL fragment,
 * otherwise do nothing. Depending on the type of element with a matching ID (ex: modal,
 * accordion, etc.) do the appropriate action (ex: open/close modal, open/close
 * accordion, etc.).
 *
 * @param {NodeList} linkedElts
 */
function akaAddAnchorLinkListeners(linkedElts) {
    linkedElts.forEach((elt) => {
        if (!elt.href) return;
        let hash = akaGetUrlFragment(elt.href);
        if (hash) {
            if (akaIsTargetModal(hash)) {
                akaInitListenerModal(hash);
            } else if (akaIsTargetTab(hash)) {
                akaInitListenerTab(hash);
            } else if (akaIsTargetAccordion(hash)) {
                akaInitListenerAccordion(hash);
            } else if (akaIsTargetScrollTo(hash)) {
                akaInitListenerScrollTo(hash);
            }
        }
    })
}

// HELPER FUNCS

/**
 * Removes the fragment from the current URL iff it equals {urlFragment}.
 *
 * @param {string} urlFragment
 */
function akaDeleteUrlFragment(urlFragment) {
    let currentUrlFragment = akaGetCurrentUrlFragment()
    if (currentUrlFragment !== urlFragment) return;
    let url = new URL(window.location.href)
    url.hash = ''
    window.history.pushState({}, document.title, url);
}

/**
 * For a list of elements, call akaConvertAbsoluteURLToRelative() if they have a
 * link set.
 *
 * @param {NodeList} linkedElements
 */
function akaConvertAbsoluteLinkedEltsToRelative(linkedElements) {
    linkedElements.forEach((elt) => {
        if (elt.href) {
            elt.href = akaConvertAbsoluteURLToRelative(elt.href);
        }
    })
}

/**
 * For links that contain fragments and point to the current page, we want to
 * convert the links from an absolute URLs to a relative URLs. Why? Some browsers
 * will reload the page when encountering ANY URL, even when the current page is
 * the same as the linked page.
 *
 * If the current page is the same as {url}, convert {url} to a relative URL.
 *
 * @param {string} url
 * @returns {string}
 */
function akaConvertAbsoluteURLToRelative(url) {
    let currentURL = window.location.origin + window.location.pathname;
    if (currentURL[currentURL.length - 1] == '/') {
        currentURL = currentURL.substring(0, currentURL.length - 1);
    }
    url = url.replace(currentURL, '');
    if (url[0] == '/') {
        url = url.substring(1);
    }
    return url;
    // return url.replace(window.location.origin, '');
}

/**
 * Returns the fragment portion of {url}. If there is no URL fragment or it's
 * an empty string, return false.
 *
 * @param {string} url
 * @returns {string|false}
 */
function akaGetUrlFragment(url) {
    let hashIndex = url.lastIndexOf("#");
    if (hashIndex == -1) return false;

    let urlFragment = url.substring(hashIndex + 1);
    return urlFragment ? urlFragment : false;
}

/**
 * Returns the fragment portion of the current URL. If there is no URL fragment,
 * return false.
 *
 * @returns {string|false}
 */
function akaGetCurrentUrlFragment() {
    return akaGetUrlFragment(window.location.href)
}

/**
 * Returns true when the URL fragment matches a modal's ID, otherwise false.
 */
function akaIsTargetModal(urlFragment) {
    let elt = document.getElementById(urlFragment);
    return elt && elt.tagName.toString().toLowerCase() == 'template';
}

/**
 * Returns true when the URL fragment matches a tab's ID, otherwise false.
 */
function akaIsTargetTab(urlFragment) {
    let elt = document.getElementById(urlFragment);
    return elt && elt.attributes.role?.nodeValue == 'tabpanel';
}

/**
 * Returns true when the URL fragment matches an accordion item's ID, otherwise false.
 */
function akaIsTargetAccordion(urlFragment) {
    let elt = document.getElementById(urlFragment);
    return elt && elt.classList.contains('collapse');
}

/**
 * Returns true when the URL fragment matches any element's ID, otherwise false.
 */
function akaIsTargetScrollTo(urlFragment) {
    return document.getElementById(urlFragment);
}

/**
 * Returns true when the linkedElt has a URL containing a URL fragment, otherwise false.
 * @param {string} linkedElt
 * @returns
 */
function akaEltHasUrlFragment(linkedElt) {
    return linkedElt && linkedElt.href && linkedElt.href.indexOf('#') != -1;
}

/**
 * Returns true when any nav menu entry URL within a navbar has a URL fragment and
 * is equal to {urlFragment}, otherwise false.
 *
 * @param {Element} nav
 * @param {string} urlFragment
 * @returns {boolean}
 */
function akaNavHasMatchingLink(nav, urlFragment) {
    const navLinkedElts = nav.querySelectorAll('.nav-link');

    let navMenuHasMatchingLink = false;
    for (let linkedElt of navLinkedElts) {
        if (akaEltHasUrlFragment(linkedElt)) {
            navMenuHasMatchingLink ||= akaGetUrlFragment(linkedElt.href) == urlFragment;
        }
    }

    return navMenuHasMatchingLink;
}

/**
 * If a nav menu entry URL contains a URL fragment equal to {urlFragment}, set that menu
 * entry to active and all other entries to inactive, otherwise do nothing.
 *
 * @param {Element} nav
 * @param {string} urlFragment
 */
function akaSetNavItemActiveState(nav, urlFragment) {
    const navItems = nav.querySelectorAll('.nav-item');

    navItems.forEach(linkedItem => {
        const link = linkedItem.querySelector('.nav-link');
        if (!link || !link.href) return;

        const linkedItemHash = akaGetUrlFragment(link.href);
        if (urlFragment == linkedItemHash) {
            linkedItem.classList.add('active', 'current-menu-item');
            linkedItem.setAttribute('aria-current', 'page');
            if (!link.querySelector('.current')) {
                let currentElt = document.createElement('span')
                link.appendChild(currentElt);
                currentElt.classList.add('sr-only', 'current')
                currentElt.innerHTML = '(current)';
            }
        }
    });
}

/**
 * Remove the active state from all menu entries within a navbar. When
 * {onlyAnchorLinks} is true, this will only affect nav menu entries that contain
 * URL fragments.
 *
 * @param {Element} nav
 * @param {bool} onlyAnchorLinks
 */
function akaClearActiveStatesFromLinks(nav, onlyAnchorLinks = false) {
    const navItems = nav.querySelectorAll('.nav-item');

    navItems.forEach(item => {
        const link = item.querySelector('.nav-link');
        if (!link || !link.href) return;

        const itemHash = akaGetUrlFragment(link.href);
        if (onlyAnchorLinks && !itemHash) return;
        item.classList.remove('active', 'current-menu-item');
        item.removeAttribute('aria-current');
        let currentElt = link.querySelector('.current');
        if (currentElt) currentElt.remove();
    });
}
